import fornecedorService from "../../../services/fornecedorService"; /*Objeto com os principais servicos de Fornecedor */
import documentosFornecService from "../../../services/documentosFornecService";
import dominioService from "../../../services/dominioService";
import validaModelFornecedor from "./validaModelFornecedor";
import util from "../../../plugins/util"; /*Objeto com metodos e funcoes utilizadas pelo sistema */
import loginService from "../../../services/loginService";
import moment from "moment";
// import { mapMutations } from "vuex";
export default {
  name: "fornecedorMixin",
  mixins: [validaModelFornecedor, util],
  components: { /*Componentes utilizados*/

  },
  created() /*Metodo de start do componente*/{
    this.getFornecedor();

    dominioService.geEnums().then(response => { /*resposta do servico*/
      this.enums = response.data; /*dados de retorno*/
    });
    this.getPontuacaoIndices();

    var vm = this;
    // Listener 1: Contrato Social alterado (COM nextTick)
    this.$root.$on('contratoSocialAlterado', function(data) {
      console.log('DEBUG fornecedorMixin: Contrato Social alterado recebido:', data);
      
      if (data.alterado && data.novaAlteracao) {
        
        // 🔧 ESPERAR O v-model PROPAGAR A NOVA DATA
        vm.$nextTick(() => {
          console.log('DEBUG fornecedorMixin: Executando helper APÓS nextTick');
          
          if (vm.isAlteracao && vm.acaoTela === "alterar" && vm.model && vm.OldModel) {
            var resultado = vm.contratoSocialRealmenteAlterado(vm.model, vm.OldModel);
            console.log("DEBUG: Helper Contrato Social (APÓS nextTick):", resultado);

            if (!resultado.contratoFoiAlterado) {
              console.log(
                "DEBUG: Evento contratoSocialAlterado recebido, mas helper indica NENHUMA alteração real. " +
                "Não ativar flag visual nem toast."
              );
              return;
            }

            console.log("DEBUG: Helper confirmou alteração REAL no Contrato Social. Ativando flags visuais.");
          }

          // === ATIVAR FLAGS ===
          vm.contratoSocialAlterado = true;
          vm.timestampUltimaAlteracaoContrato = data.timestamp || Date.now();
          vm.cnpjAtualizadoAposContratoSocial = false;

          console.log(
            "DEBUG: Flag contratoSocialAlterado ATIVADA, timestamp:",
            vm.timestampUltimaAlteracaoContrato,
            "cnpjAtualizado:",
            vm.cnpjAtualizadoAposContratoSocial
          );

          // === EMITIR CONFIRMAÇÃO PARA BANNER LOCAL ===
          if (vm.$root && vm.$root.$emit) {
            vm.$root.$emit('contratoSocialAlteradoConfirmado', {
              origem: data.origem || 'fornecedorMixin',
              timestamp: vm.timestampUltimaAlteracaoContrato
            });
            console.log('DEBUG: Emmitiu contratoSocialAlteradoConfirmado para banner local');
          }

          // === TOAST CENTRALIZADO (só para Fornecedor) ===
          if ((!vm.$verificaPerfilHabilitador || !vm.$verificaPerfilHabilitador()) && vm.$toasted && vm.$t) {
            vm.$toasted.info(
              vm.$t("messages.alertas.contratoSocialAlterado"),
              {
                duration: 10000,
                position: "top-center",
                className: "custom-toast info"
              }
            );
          }
        });
      }
    });

    // Listener 2: CNPJ atualizado
    this.$root.$on('cnpjAtualizadoAposContratoSocial', function(data) {
      console.log('DEBUG fornecedorMixin: CNPJ atualizado recebido:', data);
      
      if (data.atualizado) {
        vm.timestampUltimaAtualizacaoCNPJ = data.timestamp || Date.now();
        
        // Verificar se CNPJ foi atualizado APÓS alteração do contrato
        if (vm.contratoSocialAlterado && 
            vm.timestampUltimaAtualizacaoCNPJ > vm.timestampUltimaAlteracaoContrato) {
          
          vm.cnpjAtualizadoAposContratoSocial = true;
          vm.contratoSocialAlterado = false;
          
          console.log('DEBUG: CNPJ atualizado APÓS Contrato Social - flags resetadas');
        }
      }
    });
  },
 
  computed: {//Campos computados
    bloqueado: function () {
      return this.model.statusSolicitacao === 1 ||
        this.model.statusSolicitacao === 2 ||
        this.model.statusSolicitacao === 1 ?
        true :
        false;
    },
    isAlteracao: function () {
      // === PARA VALIDADORES: Sempre true se é solicitação tipo 2 ===
      if (this.$verificaPerfilHabilitador() && 
          this.model && 
          this.model.tipoSolicitacao === 2) {
        return true;
      }
       // === PARA CADASTRADORES: tipo 2 ===
      if (this.$verificaPerfilCadastrador() && 
          this.model && 
          this.model.tipoSolicitacao === 2) {
        return true;
      }
      // === LÓGICA ORIGINAL PARA FORNECEDORES ===
      return (this.acaoTela === "alterar" && 
              this.model.situacaoSolicitacao === 1 && 
              this.model.tipoSolicitacao === 2);
    }
  },
  watch: {
    activeTab(newTab, oldTab) {     
        var ret = true;
        switch (newTab) {
          case "tab-formulariosDeclaracoes":
           
            ret = this.validQualificacao();
            break;
        }
  
        if (ret === false) {
          this.$store.commit("setAba", {
            abaAtiva: oldTab,
          });
  
          let abas = {
            "tab-dados": 1,
            "tab-hab-juridica": 2,
            "tab-familia": 3,
            "tab-qualificacaoTecnica": 4,
            "tab-regularidadeFiscal": 5,
            "tab-qualificacao": 6,
            "tab-formulariosDeclaracoes": 7,
          };
  
          if (abas[oldTab] < abas[this.activeTab]) {
            this.abaAtiva = oldTab;
            this.activeTab = oldTab;
            return true;
          }
        }    
      
    },
  },
  data() {//Declaracao de variaveis
    return {
      acaoTela: "incluir",
      enums: {},
      tipoDocumento: {},
      listaDocsExigidos: [],
      listaDocsElegiveis: [],
      listaDocsQualificacaoTecnica: {},
      valid: true,
      activeTab: "tab-dados",
      abaAtiva: "tab-dados",
      erros: {
        erro: false,
        msg: null,
        obj: [],
        abaErro: null
      },
      model: {},
      OldModel: {},
      modelDialogRejeitar: {
        open: false,
        obs: null,
        titulo: "Motivo"
      },
      mascote: {
        msg: "Campos para preenchimento obrigatório.",
        percent: 0
      },
      upload: {
        file: null,
        novoAnexoContratoSocial: true,
        novoRG: true
      },
      listaRegularidadeFiscTrab: [],
      modelQualificacao: {
        concordataFalencia: {
          novoUpload: false,
          file: null,
          arquivoUpload: "",
          dtEmissao: ""
        },
        balancoFinanceiro: {
          novoUpload: false,
          file: null,
          arquivoUpload: "",
          dtEmissao: ""
        }
      },
      fornecedorDeclaracaoVm: {
        lista: []
      },
      fornecedorQualificacaoTecnicaVm: {
        lista: []
      },
      dialog: false,
      dialogForm: false,
      dialogFormSim: false,
      qtdSolicitacoesFornecedor: 0,
      pontuacaoIndices: [],
      totaisContas: {
        ativoTotal: 0,
        passivoTotal: 0,
      },
      diasDesdeUltimaSolicitacao: 0,
      listaDocFornecSolicitacao:[],
      listaRetornoDocumentos:[],
      fornecedorAnexoFamiliaVm:{
        lista: []
      },
      listaAnexofamilia:[],
      hasErrorFamilia: false,
      hasErrorRegularidadeFiscal: false,
      hasErroDocHabilitacao: false,
      listaDocsAnexofamiliaInvalidos:[],
      modelFamilia : {
        anexoFamiliaVm : {
          file : {
            arquivoUpload : {
              filename : {}
            }
          }
            
        }
      },
      contratoSocialAlterado: false,
      cnpjAtualizadoAposContratoSocial: false,
      timestampUltimaAlteracaoContrato: null,
      timestampUltimaAtualizacaoCNPJ: null,
      familiasJaResetadasParaReanalise: false,
      timestampResetFamilias: null,
      // estadoAnteriorContratoSocial: null,
      // estadoAnteriorCNPJ: null
    };
  },
  methods: {//Declaracao de todos os metodos

    /** Helper reutilizável: compara Contrato Social atual x antigo */
    contratoSocialRealmenteAlterado: function (modelAtual, oldModel) {
      if (!modelAtual || !oldModel) {
        console.log("DEBUG: Sem model/oldModel para comparar Contrato Social");
        return {
          contratoFoiAlterado: false,
          dataAlterada: false,
          arquivoAlterado: false,
          contratoSocialAtual: null,
          contratoSocialAntigo: null
        };
      }

      var contratoSocialAtual = null;
      var contratoSocialAntigo = null;

      // atual
      if (Array.isArray(modelAtual.documentosSolicitacao)) {
        contratoSocialAtual = modelAtual.documentosSolicitacao.find(function (doc) {
          return doc.codDocumento === 146;
        });
      }

      // antigo
      if (Array.isArray(oldModel.documentosSolicitacao)) {
        contratoSocialAntigo = oldModel.documentosSolicitacao.find(function (doc) {
          return doc.codDocumento === 146;
        });
      }

      var dataAlterada = false;
      var arquivoAlterado = false;
      var contratoFoiAlterado = false;

      if (contratoSocialAtual && contratoSocialAntigo) {
        dataAlterada =
          contratoSocialAtual.datExpedicao !== contratoSocialAntigo.datExpedicao;
        arquivoAlterado =
          contratoSocialAtual.arquivoUpload !== contratoSocialAntigo.arquivoUpload;

        contratoFoiAlterado = dataAlterada || arquivoAlterado;

        console.log("DEBUG: Helper Contrato Social:", {
          dataAlterada: dataAlterada,
          arquivoAlterado: arquivoAlterado,
          contratoFoiAlterado: contratoFoiAlterado,
          dataAtual: contratoSocialAtual.datExpedicao,
          dataAntiga: contratoSocialAntigo.datExpedicao,
          arquivoAtual: contratoSocialAtual.arquivoUpload,
          arquivoAntigo: contratoSocialAntigo.arquivoUpload
        });
      } else if (contratoSocialAtual && !contratoSocialAntigo) {
        contratoFoiAlterado = true;
        console.log("DEBUG: Helper Contrato Social: novo contrato detectado");
      } else if (!contratoSocialAtual && contratoSocialAntigo) {
        contratoFoiAlterado = true;
        console.log("DEBUG: Helper Contrato Social: contrato removido");
      } else {
        console.log("DEBUG: Helper Contrato Social: nenhum contrato encontrado");
      }

      return {
        contratoFoiAlterado: contratoFoiAlterado,
        dataAlterada: dataAlterada,
        arquivoAlterado: arquivoAlterado,
        contratoSocialAtual: contratoSocialAtual,
        contratoSocialAntigo: contratoSocialAntigo
      };
    },

    //Verificar alteração do Contrato Social para Validadores
    verificaAlteracaoContratoSocialValidador: function() {
      if (!this.model || !this.OldModel) {
        console.log('DEBUG: Sem model/OldModel para comparar');
        return false;
      }
    
      // === VALIDAÇÃO: APENAS SOLICITAÇÕES DE ALTERAÇÃO TIPO 2 ===
      if (this.model.tipoSolicitacao !== 2) {
        console.log('DEBUG: Não é solicitação de alteração (tipo:', this.model.tipoSolicitacao, ')');
        return false;
      }

      // ✅ EXPANDIR SITUAÇÕES VÁLIDAS PARA VALIDADORES:
      var situacoesValidas = [1, 2, 3, 8]; // Em análise, Aprovada, Concluída, etc.
      
      if (!situacoesValidas.includes(this.model.situacaoSolicitacao)) {
        console.log('DEBUG: Situação da solicitação não permitida (situação:', this.model.situacaoSolicitacao, ')');
        return false;
      }

      console.log('DEBUG: Solicitação de alteração VÁLIDA - situação:', this.model.situacaoSolicitacao);
    
      // === VALIDAÇÃO ADICIONAL: SOLICITAÇÃO DEVE ESTAR EM ANÁLISE ===
      // if (this.model.situacaoSolicitacao !== 1) {
        // console.log('DEBUG: Solicitação não está em análise (situação:', this.model.situacaoSolicitacao, ')');
        // return false;
      // }
    
      console.log('DEBUG: Solicitação de alteração VÁLIDA - iniciando validação rigorosa');
    
      // === BUSCAR DOCUMENTOS ATUAIS ===
      var contratoSocialAtual = null;
      var cnpjAtual = null;
      
      if (this.model.documentosSolicitacao && Array.isArray(this.model.documentosSolicitacao)) {
        contratoSocialAtual = this.model.documentosSolicitacao.find(function(doc) {
          return doc.codDocumento === 146;
        });
      }
      
      if (this.model.regularidadeFiscTrab && Array.isArray(this.model.regularidadeFiscTrab)) {
        cnpjAtual = this.model.regularidadeFiscTrab.find(function(doc) {
          return doc.tipDocumento === 1;
        });
      }
      
      // === BUSCAR DOCUMENTOS ANTIGOS (OldModel) ===
      var contratoSocialAntigo = null;
      var cnpjAntigo = null;
      
      if (this.OldModel.documentosSolicitacao && Array.isArray(this.OldModel.documentosSolicitacao)) {
        contratoSocialAntigo = this.OldModel.documentosSolicitacao.find(function(doc) {
          return doc.codDocumento === 146;
        });
      }
      
      if (this.OldModel.regularidadeFiscTrab && Array.isArray(this.OldModel.regularidadeFiscTrab)) {
        cnpjAntigo = this.OldModel.regularidadeFiscTrab.find(function(doc) {
          return doc.tipDocumento === 1;
        });
      }
      
      // === COMPARAR CONTRATO SOCIAL ===
      var contratoFoiAlterado = false;
    
      if (contratoSocialAtual && contratoSocialAntigo) {
        var dataAlterada = contratoSocialAtual.datExpedicao !== contratoSocialAntigo.datExpedicao;
        var arquivoAlterado = contratoSocialAtual.arquivoUpload !== contratoSocialAntigo.arquivoUpload;
          console.log(dataAlterada);
          console.log(arquivoAlterado);
        contratoFoiAlterado = dataAlterada || arquivoAlterado;
         console.log(contratoFoiAlterado);
        console.log('DEBUG: Comparação Contrato Social:', {
          dataAlterada: dataAlterada,
          arquivoAlterado: arquivoAlterado,
          contratoFoiAlterado: contratoFoiAlterado,
          dataAtual: contratoSocialAtual.datExpedicao,
          dataAntiga: contratoSocialAntigo.datExpedicao,
          arquivoAtual: contratoSocialAtual.arquivoUpload,
          arquivoAntigo: contratoSocialAntigo.arquivoUpload
        });
      } else if (contratoSocialAtual && !contratoSocialAntigo) {
        contratoFoiAlterado = true;
      
      } else {
    
      }
      
      if (!contratoFoiAlterado) {
       
        return false;
      }
      
      // === COMPARAR CNPJ ===
      var cnpjFoiAtualizado = false;
      
      if (cnpjAtual && cnpjAntigo) {
        var dataEmissaoAlterada = cnpjAtual.dtEmissao !== cnpjAntigo.dtEmissao;
        var arquivoCNPJAlterado = cnpjAtual.arquivoUpload !== cnpjAntigo.arquivoUpload;
        
        cnpjFoiAtualizado = dataEmissaoAlterada || arquivoCNPJAlterado;
        
        console.log('DEBUG: Comparação CNPJ:', {
          dataAlterada: dataEmissaoAlterada,
          arquivoAlterado: arquivoCNPJAlterado,
          cnpjFoiAtualizado: cnpjFoiAtualizado,
          dataAtual: cnpjAtual.dtEmissao,
          dataAntiga: cnpjAntigo.dtEmissao,
          arquivoAtual: cnpjAtual.arquivoUpload,
          arquivoAntigo: cnpjAntigo.arquivoUpload
        });
      } else if (cnpjAtual && !cnpjAntigo) {
        cnpjFoiAtualizado = true;
     
      } else {

      }
      
      // === VALIDAÇÃO FINAL: AMBOS ALTERADOS ===
      if (contratoFoiAlterado && cnpjFoiAtualizado) {
        if (contratoSocialAtual.datExpedicao && cnpjAtual.dtEmissao) {
          try {
            var dateContrato = new Date(contratoSocialAtual.datExpedicao);
            var dateCNPJ = new Date(cnpjAtual.dtEmissao);
            
            if (dateCNPJ >= dateContrato) {
          
              return true;
            } else {
          
              return false;
            }
          } catch (error) {
        
            return true;
          }
        }
        
     
        return true;
      }
      
     return false;
    },

    verificaAlteracaoContratoSocial: function() {
      const isHabilitador = this.$verificaPerfilHabilitador
        ? this.$verificaPerfilHabilitador()
        : false;
    
      const isCadastrador = this.$verificaPerfilCadastrador
        ? this.$verificaPerfilCadastrador()
        : false;
    
      const isFluxoAlteracao = this.isAlteracao && this.acaoTela === "alterar";
    
      console.log("DEBUG verificaAlteracaoContratoSocial:", {
        isAlteracao: this.isAlteracao,
        perfilHabilitador: isHabilitador,
        perfilCadastrador: isCadastrador,
        temOldModel: !!this.OldModel,
        temModel: !!this.model,
        acaoTela: this.acaoTela,
        situacaoSolicitacao: this.model ? this.model.situacaoSolicitacao : null,
        tipoSolicitacao: this.model ? this.model.tipoSolicitacao : null
      });
    
      // 🔹 Regra de ativação:
      // - Validador / Fornecedor: apenas em fluxo de ALTERAÇÃO
      // - Cadastrador: também participa (edições feitas por ele)
      if (!isFluxoAlteracao && !isCadastrador) {
   
        return false;
      }
    
      // 🔹 Validadores: usam caminho específico
      if (isHabilitador) {
        return this.verificaAlteracaoContratoSocialValidador();
      }
    
      // 🔹 Fornecedor + Cadastrador: usam helper comum
      if (!this.OldModel || !this.model) {
        return false;
      }
    
      var resultado = this.contratoSocialRealmenteAlterado(this.model, this.OldModel);
    
      console.log(
        "DEBUG Contrato social alterado (Fornecedor/Cadastrador, helper):",
        resultado.contratoFoiAlterado
      );
    
      return resultado.contratoFoiAlterado;
    },
    

    /**
     * NOVO MÉTODO: Validação cruzada Contrato Social -> Cartão CNPJ
     */
    validaContratoSocialCartaoCNPJ: function() {
      console.log('DEBUG validaContratoSocialCartaoCNPJ:', {
        isAlteracao: this.isAlteracao,
        perfilHabilitador: this.$verificaPerfilHabilitador(),
        contratoSocialAlterado: this.contratoSocialAlterado,
        cnpjAtualizadoAposContratoSocial: this.cnpjAtualizadoAposContratoSocial,
        acaoTela: this.acaoTela
      });      
 
      // === PARA VALIDADORES: Usar detecção rigorosa ===
      if (this.$verificaPerfilHabilitador()) {
        var contratoAlterado = this.verificaAlteracaoContratoSocialValidador();
    
        if (contratoAlterado) {
     
          var familiasResetadas = this.resetarAprovacoesFamilias();
    
          if (familiasResetadas) {
          
          }
        }
    
        // SEMPRE retornar válido para Validadores (não bloquear navegação)
        return { valido: true };
      }
    
      // === PARA FORNECEDORES: Normalizar com helper ===
      // Se, em relação ao OldModel, o Contrato Social NÃO foi alterado,
      // não deve exigir atualização de CNPJ, mesmo que o usuário tenha clicado na mesma data.
      if (this.isAlteracao && this.acaoTela === "alterar" && this.OldModel && this.model) {
        var resultado = this.contratoSocialRealmenteAlterado(this.model, this.OldModel);
    
        if (!resultado.contratoFoiAlterado) {
          console.log("DEBUG: validaContratoSocialCartaoCNPJ - contrato NÃO foi alterado (helper) -> valido = true");
          return { valido: true };
        }
      }
    
      // === PARA FORNECEDORES: Usar flags de comunicação APENAS quando houve alteração real ===
      if (this.contratoSocialAlterado && !this.cnpjAtualizadoAposContratoSocial) {
        return {
          valido: false,
          mensagem: 'A atualização do Contrato Social exige a atualização do Cartão CNPJ na aba "Regularidade Fiscal e Trabalhista"'
        };
      }
    
      return { valido: true };
    },

    setAba(abaAtiva) {
      this.erros = {
        erro: false,
        msg: null,
        obj: [],
        abaErro: null
      };
      
      let abas = {
        "tab-dados": 1,
        "tab-hab-juridica": 2,
        "tab-familia": 3,
        "tab-qualificacaoTecnica": 4,
        "tab-regularidadeFiscal": 5,
        "tab-qualificacao": 6,
        "tab-formulariosDeclaracoes": 7
      };

      this.$store.commit("setAba", {
        abaAtiva: abaAtiva
      });

      if (abas[abaAtiva] < abas[this.activeTab]) {
        this.abaAtiva = abaAtiva;

        this.activeTab = abaAtiva ;

        return true;
      }

      Promise.all([this.cadastroFornecedor(true)]).then(valida => {
        if (valida[0]) {
          if (this.validaModel(this.activeTab, abaAtiva)) {
            this.abaAtiva = abaAtiva;
            this.activeTab = abaAtiva;
          }
        }
      });
    },

    listaExigidos() {
      // Lista de documentos exigíveis
      var guarda = [];
    
      // Verificação de nulidade
      if (!this.listaDocsQualificacaoTecnica || !Array.isArray(this.listaDocsQualificacaoTecnica.lista)) {
        console.warn("listaDocsQualificacaoTecnica.lista está indefinido ou não é um array.");
        this.listaDocsExigidos = [];
        return;
      }
    
      this.listaDocsExigidos = this.listaDocsQualificacaoTecnica.lista.filter(item => {
        // #132793 - Cadastrar e Consultar Qualificacao Tecnica
        if (item.codDocumento === 109) return false;
    
        let documentoJaAnalisado = guarda.find(x => x.codDocumento === item.codDocumento);
    
        if (!documentoJaAnalisado && item.exigido === "S") {
          guarda.push(item);
          return true;
        } else {
          return false;
        }
      });

      //this.mergeListaQualificacaoFornecedor("exigidos");
      
      this.listaElegiveis();
    },
    listaElegiveis() {
      //lista de documentos elegiveis
      var guarda = [];
      this.listaDocsElegiveis = this.listaDocsQualificacaoTecnica.lista.filter(
        item => {
          if (
            !guarda.find(x => x.codDocumento === item.codDocumento) &&
            !this.listaDocsExigidos.find(
              x => x.codDocumento === item.codDocumento
            ) &&
            item.elegivel === "S"
          ) {
            guarda.push(item);
            return true;
          } else {
            return false;
          }
        }
      );
     // this.mergeListaQualificacaoFornecedor("elegiveis");

     //  this.fornecedorQualificacaoTecnicaVm.lista = this.listaDocsExigidos.concat(
     //   this.listaDocsElegiveis
     // );
    },

    getFornecedor() {
      //Método para resgate da solicitação do fornecedor
      this.$mostrarPreload(); /*Exibir o PreLoad*/
      this.acaoTela = this.$route.params.alterar ? this.$route.params.alterar : "incluir";

      let IdFornecSolicitacao = (this.$route.params.id) ? this.$route.params.id : null;
      let servico;

      if((
      (!this.$verificaPerfilHabilitador() ||
        !this.$verificaPerfilCadastrador()) &&
        this.acaoTela === "alterar") ||
        this.acaoTela === "modificar") {
        servico = fornecedorService.getSolicitarAlteracao;
      } else if (this.$verificaPerfilHabilitador() ||
        this.$verificaPerfilCadastrador()) {
        servico = fornecedorService.getSolicitacao;
      } else {
        servico = fornecedorService.getFornecedor;
      }

      servico(IdFornecSolicitacao).then(response => { /*resposta do servico*/
        this.model = response.data.novoModel ? response.data.novoModel : response.data; /*dados de retorno*/
  
        this.OldModel = response.data.oldModel ? response.data.oldModel : {};
        // === SALVAR ESTADO INICIAL DOS DOCUMENTOS ===
        // this.salvarEstadoInicialDocumentos();
        // Resetar flags
        this.familiasJaResetadasParaReanalise = false;
        this.timestampResetFamilias = null; 

        this.montaAnexoFamilia();
        this.setCamposFornecedor();
        this.getDocumentosFornecedor(this.model.idFornecSolicitacao)

    
        // NOVA IMPLEMENTAÇÃO: Atualizar o fornecedorAtivo no Vuex store para sincronizar com o Resumo de Dados
        this.$store.commit('setFornecedorAtivo', {
          numCgcFornecedor: this.model.numCgcFornecedor,
          dscRazaoSocial: this.model.nomFornecedor,
          numCep: this.model.endCep,
          dscLogradouro: this.model.endLogradouro,
          dscComplemento: this.model.endComplemento,
          numEndereco: this.model.endNumero,
          dscBairro: this.model.endBairro,
          dscCidade: this.model.endCidade,
          tipoFornecedor: this.model.tipFornecedor
        });

        this.$nextTick(() => {
       
          this.validaContratoSocialCartaoCNPJ();

          if (this.$verificaPerfilHabilitador && this.$verificaPerfilHabilitador()) {
            const contratoAlterado = this.verificaAlteracaoContratoSocialValidador();
            console.log(contratoAlterado);
             console.log("contratoAlterado");
            if (contratoAlterado && !this.familiasJaResetadasParaReanalise) {
            
              const resetou = this.resetarAprovacoesFamilias();
              if (resetou) {
                this.familiasJaResetadasParaReanalise = true;
                this.timestampResetFamilias = Date.now();
              }
            }
          }
  
          this.$removePreload(); // fechar dentro do nextTick
        });
      })
      .catch(error => {
        this.$removePreload(); /*Ocultar o PreLoad*/
        if (error.data.message &&
        (  (error.data.message).toLowerCase().indexOf("análise") !== -1 || (error.data.message).toLowerCase().indexOf("solicitação inicial") !== -1 )
          ) {
            this.verificaPerfil();
        }
        else{
          this.verificaPermissaoAlteracao(error);
        }
        this.verificaErro(error);
      });
    },
    verificaPerfil(){
      if(this.$verificaPerfilHabilitador())
        this.$router.push("/arearestrita/habilitador/solicitacao");
      else if(this.$verificaPerfilCadastrador())
        this.$router.push("/arearestrita/cadastrador/solicitacao");
      else
        this.$router.push("/historico-solicitacoes");
    },
    verificaPermissaoAlteracao(error){
      if(this.acaoTela === "alterar")
      {
        if (error.data.message && (error.data.message).toLowerCase().indexOf("não possui permissão para alteração") !== -1) {
          this.$router.push("/fornecedor-painel");
        }
      }
    },
    verificaErro(error){
      if (error.status == 403) {
        this.$toasted.error("Acesso não permitido!");
        if(this.$verificaPerfilHabilitador()){
         this.$router.push("/arearestrita/habilitador/solicitacao");
        }else if(this.$verificaPerfilCadastrador()){
         this.$router.push("/arearestrita/cadastrador/solicitacao");
        }else{
         this.$router.push("/historico-solicitacoes");
        }
     }
    },
    setCamposFornecedor(){
      
      if (this.model.endCep != null && this.model.endCep.length < 8){
        const cepFormatado = this.validaCepFornecedor(this.model.endCep);
        this.model.endCep = cepFormatado;
      }

      if (this.model.codPais == null || this.model.codPais === "")
        this.model.codPais = 1058;

      if ((this.model.codUf == null || this.model.codUf === "") && this.model.flagEstrangeiro === '0')
        this.model.codUf = "BA";

      if (this.model.categoria == null || this.model.categoria === "")
        this.model.categoria = "NO";

      if (this.model.flagEstrangeiro == null || this.model.flagEstrangeiro === "")
        this.model.flagEstrangeiro = "0";

      if (this.model.flagSociedadeAnonima == null || this.model.flagSociedadeAnonima === "")
        this.model.flagSociedadeAnonima = "0";

      if (this.model.familiaSolicitacao.length) {
        this.getListaDocsQualificacaoTecnica();
      }
    },

    validaCepFornecedor(cep){
      //valida se o cep não possui o digito a esquerda e o completa
      cep = cep.replace(/[^0-9]/g, "");
      let cepTam = cep.length;
     
      if(cepTam < 8){
        return ["0",cep].join("");
      }
      else{
        return cep;
      }
     // return adcionaZeroEsquerda(cep, true);
    },
    adcionaZeroEsquerda(cep,isCep){
  
      if(!isCep) return cep;
      if(cep.length < 8 && isCep) return cep.padStart(8, '0')
      return cep;
    },
    getDocumentosFornecedor(idFornecSolicitacao) {
      documentosFornecService.getDocumentosFornecedorSolicitacao(idFornecSolicitacao).then(response => {
        this.listaDocFornecSolicitacao = response.data;
        
        // 🔧 SINCRONIZAR listaDocFornecSolicitacao → model.documentosSolicitacao
        if (this.model.documentosSolicitacao && Array.isArray(this.model.documentosSolicitacao)) {
          this.model.documentosSolicitacao.forEach(modelDoc => {
            const listaDoc = this.listaDocFornecSolicitacao.find(doc => doc.codDocumento === modelDoc.codDocumento);
            if (listaDoc && listaDoc.docSolicitacao) {
              modelDoc.datExpedicao = listaDoc.docSolicitacao.datExpedicao;
              modelDoc.arquivoUpload = listaDoc.docSolicitacao.arquivoUpload;
              console.log('DEBUG: SINCRONIZOU getDocumentosFornecedor:', modelDoc.codDocumento, modelDoc.datExpedicao);
            }
          });
        }
        
        const rgDoc = this.listaDocFornecSolicitacao.find(x => x.codDocumento == 140);
        if (rgDoc && rgDoc.docSolicitacao && rgDoc.docSolicitacao.arquivoUpload) {
          this.upload.novoRG = false;
        }
      });
    },

    montaListaDocumentosSolicitacao(){
      //Montar a lista de documentos que devem ser cadastrados e alterados no banco
      this.listaRetornoDocumentos = [];
      this.listaDocFornecSolicitacao.filter(item => {
        if (item.docSolicitacao)
        {
            item.docSolicitacao.codDocumento = item.codDocumento
            item.docSolicitacao.idFornecSolicitacao = this.model.idFornecSolicitacao
            item.docSolicitacao.numHabilitacao = item.numHabilitacao
        }
        this.listaRetornoDocumentos.push({
          documentosSolicitacao: Object.assign({}, item.docSolicitacao),
          file: item.file
        })
        item.file = null
      });

      return this.listaRetornoDocumentos
    },

    montaAnexoFamilia(){
      this.model.familiaSolicitacao.filter(item => {
        let anexo =
        {
          anexoFamiliaSituacao: item.anexoFamilia ? item.anexoFamilia.anexoFamiliaSituacao : null,
          arquivoUpload: item.anexoFamilia ? item.anexoFamilia.arquivoUpload : null,
          codControle: item.anexoFamilia ? item.anexoFamilia.codControle : null,
          codDocumento: 109,
          dtRejeicao: item.anexoFamilia ? item.anexoFamilia.dtRejeicao : null,
          idFamiliaSolicitacao: item.anexoFamilia ? item.anexoFamilia.idFamiliaSolicitacao : item.idFamiliaFornec,
          idMotivoIndeferimentoArquivo: item.anexoFamilia ? item.anexoFamilia.idMotivoIndeferimentoArquivo : null,
          file: {
            arquivoUpload: null,
            novoUpload: item.anexoFamilia && item.anexoFamilia.arquivoUpload ? false : true
          }
        }
        item.anexoFamilia = (item.anexoFamilia) ? {...item.anexoFamilia,...anexo} : anexo;
      });
    },

    getPontuacaoIndices() {
      //Método para buscar a pontuação de indices
      dominioService.getPontuacaoIndices().then(response => { /*resposta do servico*/
        this.pontuacaoIndices = response.data; /*dados de retorno*/
      });
    },

    cadastroFornecedor(clickAba) {
      
        this.$store.commit("setCalcLimpa", {
           setCalcLimpa: 2
       });
         
      
      //Método acionado sempre na mudança de aba
      //Persistir no banco as alterações da solicitação
      
      this.erros = {
        erro: false,
        msg: null,
        obj: [],
        abaErro: null
      };
    
      if (this.validForm()) {

        // === NOVA IMPLEMENTAÇÃO: VALIDAÇÃO CRUZADA CONTRATO SOCIAL → CARTÃO CNPJ ===
  
         // 🔧 SINCRONIZAR modelQualificacao → model ANTES da validação
        // if (this.modelQualificacao && this.modelQualificacao.balancoFinanceiro) {
        //   this.model.balancoFinanceiro = { ...this.model.balancoFinanceiro, ...this.modelQualificacao.balancoFinanceiro };
        //   console.log('DEBUG: SINCRONIZOU modelQualificacao → model.balancoFinanceiro');
        // } 

        // Executar validação cruzada
        const validacaoContratoSocial = this.validaContratoSocialCartaoCNPJ();
        
        console.log(validacaoContratoSocial);
        console.log(this.activeTab);
        // ───────────────────────────────────────────────────────────────
        // REGRA 1: BLOQUEAR APENAS SE ESTIVER NA ABA DE REGULARIDADE FISCAL
        // ───────────────────────────────────────────────────────────────
        
        if (this.activeTab === 'tab-regularidadeFiscal' || this.activeTab === 'tab-formulariosDeclaracoes') {
            // ✅ Está na aba de Regularidade Fiscal → BLOQUEAR se inválido
            
            if (!validacaoContratoSocial.valido) {
                // ❌ BLOQUEIA NAVEGAÇÃO nesta aba
                this.erros = {
                    erro: true,
                    msg: validacaoContratoSocial.mensagem,
                    obj: ['contratoSocial', 'cartaoCNPJ'],
                    abaErro: 'tab-regularidadeFiscal'
                };
                
                this.$toast.error(validacaoContratoSocial.mensagem);
                
                return false; // ❌ BLOQUEIA - Não permite avançar
            }
        } else {
            // ───────────────────────────────────────────────────────────
            // REGRA 2: NAS OUTRAS ABAS - APENAS MARCAR FLAG (NÃO BLOQUEIA)
            // ───────────────────────────────────────────────────────────
            
            if (!validacaoContratoSocial.valido) {
                // ✅ NÃO está na aba de Regularidade Fiscal → APENAS ALERTAR
                
                // Marcar flag para exibir alerta visual quando chegar na aba
                this.contratoSocialAlterado = true;
                
                console.log('[INFO] Contrato Social alterado - Alerta ativo mas permite navegação');
                
                // ✅ NÃO retorna false - Permite prosseguir normalmente
            }
        }
        
        // Verificar se está na aba de dados e não é mudança de aba
        if (this.activeTab === "tab-dados" && !clickAba) {
            if (this.precisaConfirmarDados()) {         
                this.dialogConfirmacaoDados = true;
                return true;
            }
        }

        return fornecedorService
          .cadastrarfornecedor({
            fornecedorSolicitacao: this.model,
            file: this.upload.file,
            listaRegularidadeFiscTrab: this.listaRegularidadeFiscTrab,
            listaDocumentosSolicitacao: this.montaListaDocumentosSolicitacao(),
            listaDeclaracao: this.fornecedorDeclaracaoVm.lista,
            listaQualificacaoTecnica: this.listaQualificacaoTecnica,
            modelQualificacao: this.modelQualificacao,
            listaAnexofamilia: this.listaAnexofamilia,
            aba: this.activeTab
          },)
          .then(response => { /*resposta do servico*/

            this.model = response.data; /*dados de retorno*/           
            this.upload.file = null;

            /* verifica os docs de PJ ou PF que precisam atualizar */
            this.verificaDocsPfPj();

            this.modelQualificacao.concordataFalencia.limparArquivoUpload = false;
            this.modelQualificacao.balancoFinanceiro.limparArquivoUpload = false;
            this.modelQualificacao.balancoFinanceiro.limparArquivoUpload02 = false;
            this.listaRegularidadeFiscTrab = [];
            this.listaQualificacaoTecnica = [];
            this.listaDocumentosSolicitacao = [];
            this.listaDeclaracao = [];
            this.fornecedorDeclaracaoVm= Object.assign({},{lista:[]},{});
            this.montaAnexoFamilia();

          
            if (this.$verificaPerfilHabilitador()) {
              this.modelQualificacao.concordataFalencia.file = null;
              
              this.modelQualificacao.balancoFinanceiro.file = null;
              this.modelQualificacao.balancoFinanceiro.file02 = null;
            }
            if (this.abaAtiva === "tab-qualificacaoTecnica" && !this.validModelRegularidadeFiscal()) {
              return false;
            }

            console.log('DEBUG BALANÇO após SAVE:', {
              file:
                this.modelQualificacao &&
                this.modelQualificacao.balancoFinanceiro &&
                this.modelQualificacao.balancoFinanceiro.file
                  ? this.modelQualificacao.balancoFinanceiro.file
                  : null,
            
              novoUpload:
                this.modelQualificacao &&
                this.modelQualificacao.balancoFinanceiro &&
                this.modelQualificacao.balancoFinanceiro.novoUpload
                  ? this.modelQualificacao.balancoFinanceiro.novoUpload
                  : null,
            
              backend_arquivo:
                this.model &&
                this.model.balancoFinanceiro &&
                this.model.balancoFinanceiro.arquivoUpload
                  ? this.model.balancoFinanceiro.arquivoUpload
                  : null
            });
            


            this.getDocumentosFornecedor(this.model.idFornecSolicitacao);
           
            // NOVA IMPLEMENTAÇÃO: Atualizar o fornecedorAtivo no Vuex store para sincronizar com o Resumo de Dados
            this.$store.commit('setFornecedorAtivo', {
              numCgcFornecedor: this.model.numCgcFornecedor,
              dscRazaoSocial: this.model.nomFornecedor,
              numCep: this.model.endCep,
              dscLogradouro: this.model.endLogradouro,
              dscComplemento: this.model.endComplemento,
              numEndereco: this.model.endNumero,
              dscBairro: this.model.endBairro,
              dscCidade: this.model.endCidade,
              tipoFornecedor: this.model.tipFornecedor
            });

            // Verificar se precisa confirmar dados
            if (this.activeTab === "tab-dados" && !clickAba) {
              if (this.precisaConfirmarDados()) {
                this.dialogConfirmacaoDados = true;
                return true;
              }
            }

            // === NOVA IMPLEMENTAÇÃO: RESET FLAG APÓS SUCESSO ===
            // Após salvar com sucesso, resetar flag se estava marcado
            if (validacaoContratoSocial.valido && this.contratoSocialAlterado) {
                this.contratoSocialAlterado = false;
            }
            // === FIM DO RESET ===

            // método avança aba           
            this.callAvancaAba(clickAba);

            return true;
          });

      } else {
        return false;
      }
    },

    // Verificar se precisa confirmar dados
    precisaConfirmarDados() {
      fornecedorService.getDiasUltimaSolicitacao(this.model.idFornecSolicitacao)
      .then( response => {/*resposta do servico*/
        this.diasDesdeUltimaSolicitacao =   response.data;        
      });
      // Se não tiver data de solicitação, precisamos confirmar os dados
      if (!this.model.dataSolicitacao) {
        return true;
      }

      return this.diasDesdeUltimaSolicitacao>= 90;
    },

    // Métodos para os botões do popup
    editarDados() {
      this.dialogConfirmacaoDados = false;
      // Já estamos na aba de dados, então não precisamos fazer nada
    },

    confirmarDados() {
      this.dialogConfirmacaoDados = false;
      
      fornecedorService.confirmarDadosFornecedor(this.model.idFornecSolicitacao)
        .then(() => {
     
          // Atualizar o modelo com a nova data de confirmação
          this.model.dataSolicitacao = new Date();
          
          // Avançar para a próxima aba
          this.avancaAba();
        })
        .catch(error => {
          console.error("Erro ao confirmar dados:", error);
          this.verificaErro(error);
        });
    },

    verificaDocsPfPj(){
      if (this.model.tipFornecedor === "J") // tipFornecedor é do tipo string
        this.upload.novoAnexoContratoSocial = this.model.arquivoUpload ? false: true;
      else
        this.upload.novoRG = this.listaDocFornecSolicitacao.find(x=> x.codDocumento == 140).docSolicitacao.arquivoUpload ? false: true;
    },

    // método avança aba
    callAvancaAba(clickAba){     
      if (!clickAba) {
        this.setAbaVoltar(this.activeTab);
        this.avancaAba();
      }
    },

    validaPopUpEnvioPrimeiraSolicitacao(numCgcFornecedor){
      
      let cgcFornecedor = numCgcFornecedor;

        fornecedorService.getQtdSolicitcaoesFornec(cgcFornecedor)
          .then( response => {/*resposta do servico*/
            this.qtdSolicitacoesFornecedor  =  response.data;

             return this.qtdSolicitacoesFornecedor;
          });
    },

    avancaAba() {
      //Método para acionar a aba correspondente
     
      document.scrollingElement.scrollTop = 0;
      if (this.activeTab === "tab-dados") {
        if (this.model.tipFornecedor !== "F")
          this.abaAtiva = "tab-hab-juridica";
        else this.abaAtiva = "tab-familia";
      } else if (this.activeTab === "tab-familia") {       
       
          this.listaExigidos();
          
          if( this.listaDocsExigidos.length > 0 || this.listaDocsElegiveis.length >0)
          {
            this.abaAtiva = "tab-qualificacaoTecnica";
          }
          else
          {
            this.abaAtiva = "tab-regularidadeFiscal";
          }
      } else if (this.activeTab === "tab-qualificacaoTecnica") {
        this.abaAtiva = "tab-regularidadeFiscal";
      } else if (this.activeTab === "tab-hab-juridica") {
        this.abaAtiva = "tab-familia";
      } else if (this.activeTab === "tab-regularidadeFiscal") {
        if (this.model.tipoCertificado !== 1){
          this.abaAtiva = "tab-formulariosDeclaracoes";
        }else{ 
          
          this.abaAtiva = "tab-qualificacao";
        }
      } else if (this.activeTab === "tab-qualificacao") {
        this.abaAtiva = "tab-formulariosDeclaracoes";
      }
      
      this.activeTab = this.abaAtiva;

      this.$setAba(this.activeTab);
      this.setAbaVoltar(this.abaAtiva);
    },

    validDadosBasicos() {
      //Validar dados basicos
      return this.$refs.dadosBasicosForm.validate();
    },

    validHabJuridica() {
      //Validar habilitação Juridica
      if (this.$refs.habilitacaoJuridicaForm.$children[0].$refs.docHabilitacaoJuridicaForm.validate()) {
        if (
          !this.model.fornecedoresHabilitacaoJuridica ||
          !this.model.fornecedoresHabilitacaoJuridica.length
        ) {
          this.setErro("Cadastre pelo menos um Dirigente ou um Sócio.", "tab-hab-juridica")
          return false;
        }

        //Caso haja algum sócio/dirigente com documento anexo inválido.
        if (
           this.model.fornecedoresHabilitacaoJuridica &&
           this.model.fornecedoresHabilitacaoJuridica.length
         ) {

          let docInvalido = this.model.fornecedoresHabilitacaoJuridica.filter(item => 
            item.arquivoUpload === "Não Encontrado");        

          if (docInvalido.length > 0){
            this.setErro("Anexe o documento do Dirigente/Sócio: " + (docInvalido[0].nome), "tab-hab-juridica")
            return false;
          }
        }

        let percentTotal = 0;

        this.model.fornecedoresHabilitacaoJuridica.filter(item => {
          if (item.tipoCadastro === "S") {
            percentTotal += item.percentual;
          }
        });

        if (percentTotal && parseFloat(percentTotal.toFixed(2)) < 100) {
          this.setErro(this.$t("messages.validacao.percentualMenorQue100"), "tab-hab-juridica");
          return false;
        } else {
          return true;
        }
      }else{
        return false;
      }
    }, 

    validHabJuridicaDocSolic() {
      //Validar habilitação Juridica
      console.log(this.abaAtiva);
      const docs = Array.isArray(this.model.documentosSolicitacao)
      ? this.model.documentosSolicitacao
      : [];
      const finalidade = Number(this.model.finalidadeEmpresa);

      // Função utilitária: verifica existência de documento com código X e arquivoUpload válido
      const hasValid = (codigo) =>
        docs.some(d =>
          Number(d.codDocumento) === codigo &&
          d.arquivoUpload != null &&
          String(d.arquivoUpload).trim() !== ''
        );
      
      if (finalidade === 1 && this.model.flagSociedadeAnonima != "1") {
        // precisa ao menos um 146 com arquivoUpload não-nulo
        if (!hasValid(146)) {
          this.setErro(
            'O documento Contrato Social é obrigatório',
            'tab-hab-juridica'
          );
          
          return false;
        }
      }
      else if (finalidade === 0 || (finalidade === 1 && this.model.flagSociedadeAnonima == "1")) {
        // precisa 143 e 145 com arquivoUpload não-nulo
        const ok143 = hasValid(143);
        const ok145 = hasValid(145);
        if (!ok143 || !ok145) {
          this.setErro(
            'O documento Estatuto Social e ATA são obrigatórios',
            'tab-hab-juridica'
          );
        
          return false;
        }
      }

      return true;
    },

    
    validFamilia() {
      // Inicializa a variável de controle (start debbug)
      // let isValid = true;
    
      // Verifica se há sócios servidores públicos
      const possuiSocioServidor =
        this.model.fornecedoresHabilitacaoJuridica.some(item => item.isFuncionarioPublico) ||
        this.model.isFuncionarioPublico;
    
      // Se não houver sócios servidores, a validação de famílias não se aplica
      if (!possuiSocioServidor) {
        return true;
      }
    
      // Verifica se há famílias não salvas
      if (this.$refs.familia.$children[0].$children[0].$el[4]._value != null) {
        this.setErro(this.$t("messages.validacao.familiaSemSalvar"), "tab-familia");
        return false;
      }

      if (this.model.familiaSolicitacao.length > 0) {
        if(this.$refs.familia.$children[0].$refs.boxFamilias.validate()){
          this.listaAnexofamilia = [];
          if(this.model.familiaSolicitacao){
            this.model.familiaSolicitacao.filter(item  => {
              this.listaAnexofamilia.push({
                  anexoFamilia:{
                    idFamiliaSolicitacao: item.anexoFamilia.idFamiliaSolicitacao,
                    codDocumento: item.anexoFamilia.codDocumento,
                    arquivoUpload: item.anexoFamilia.arquivoUpload,
                    codControle: item.anexoFamilia.codControle,
                    AnexoFamiliaSituacao: item.anexoFamilia.file.novoUpload !== undefined ? null : item.anexoFamilia.anexoFamiliaSituacao,
                    idMotivoIndeferimentoArquivo: item.anexoFamilia.idMotivoIndeferimentoArquivo,
                    dtRejeicao: item.anexoFamilia.dtRejeicao
                  },
                  file: item.anexoFamilia.file
              });
            });
          }

          //verifica se alguma familia possui documentos invalidos e bloqueia o avanço          
            if (this.listaAnexofamilia) {
              this.listaDocsAnexofamiliaInvalidos = [];
                this.listaAnexofamilia.filter( item => {
                if(item.file.novoUpload == true) {                
                  return false; 
                }
                let familia = this.model.familiaSolicitacao.find(f => f.idFamiliaFornec === item.anexoFamilia.idFamiliaSolicitacao);

                if (familia && parseInt(familia.codGrupo) < 10) {

                if(this.model.tipoCertificado !== 3 && (item.anexoFamilia.arquivoUpload === "Não Encontrado") 
                   && (item.file.novoUpload !== undefined && item.file.novoUpload == false) ){

                    this.listaDocsAnexofamiliaInvalidos.push(item);
                    this.hasErrorFamilia = true;
                    this.setErro("Arquivo Inválido Insira o Atestado de Capacidade Técnica para cada família Indicada", "tab-familia");
                }
              }                
              });

              if (this.hasErrorFamilia === true && this.listaDocsAnexofamiliaInvalidos.length>0){ 
                return false; 
              }
            }


          this.hasErrorFamilia = false;
          return true;
        }else{
         
          this.hasErrorFamilia = true;
          this.setErro("Cadastre o Atestado de Capacidade Técnica para cada família", "tab-familia");
          return false
        }
      } else {       
        this.setErro(this.$t("messages.validacao.familiaVazia"), "tab-familia");
        return false;
      }      
    },

    validQualificacaoTecnica() {
      //Validar qualificação tecnica
 
      if (this.$refs.qualificacaoTecnica.validate()) {
        this.listaQualificacaoTecnica = [];



        this.fornecedorQualificacaoTecnicaVm.lista.filter(item => {
          this.listaQualificacaoTecnica.push({
            qualificacaoTecnica: {
              codDocumento: item.codDocumento,
              numDocumento: item.numDocumento,
              dtVencimento: item.dtVencimento,
              arquivoUpload: item.arquivoUpload,
              codControle: item.codControle,
              qualificacaoTecnicaSituacao: item.qualificacaoTecnicaSituacao,
              idMotivoIndeferimentoArquivo: item.idMotivoIndeferimentoArquivo,
              dtRejeicao: item.dtRejeicao
            },
            file: item.file
          })
        });

        return true;

      }

      return false;
    },

    validaAnoAnterior(data, quantosAnos) {   
      
      // Verificação inicial
      if (this.modelQualificacao.balancoFinanceiro.file02 === null && quantosAnos == 2 && this.obrigarBalanco2() != 'obrigabalanco2') {
          return true;
      }
       
      let regularidadeFiscTrabAberturaEmp = this.model.regularidadeFiscTrab.find(x => x.tipDocumento === 1);
      const anoAberturaEmpresa = moment(regularidadeFiscTrabAberturaEmp.dtAberturaEmpresa).year(); 
      // const dataSolicitacao = moment(this.model.dataSolicitacao); // Usa moment para manipular a data
     
      // Se a data estiver vazia e certas condições forem atendidas
      if (data === '' && (this.modelQualificacao.balancoFinanceiro.file02 === null && this.obrigarBalanco2() != 'obrigabalanco2')) {
          return true;
      } 
      
      // Se estamos homologando
      if (this.esta_homologando) {
        const anoAtual = new Date().getFullYear();
        const anoData = moment(data).year(); // Obtém o ano da data fornecida
        const mesSolicitacao = new Date().getMonth() + 1; // Mês de dataSolicitacao (0-11, por isso +1)
      
        if (quantosAnos === 1) {
  
          if(anoAberturaEmpresa === anoData){
            return true;
          }
          // Regra para Balanço 01
          if (mesSolicitacao <= 6) {
            // Primeiro semestre: ano pode ser do ano anterior ou dois anos antes
            return anoData === anoAtual - 1 || anoData === anoAtual - 2;
          } else {
            // Segundo semestre: ano pode ser apenas do ano anterior
            return anoData === anoAtual - 1;
          }
        } else if (quantosAnos === 2) {
          // Regra para Balanço 02
          if (mesSolicitacao <= 6) {
            // Primeiro semestre: ano pode ser dois ou três anos antes
            return anoData === anoAtual - 2 || anoData === anoAtual - 3;
          } else {
            // Segundo semestre: ano pode ser apenas dois anos antes
            return anoData === anoAtual - 2;
          }
        }
      } else {
        // Caso não esteja homologando
        const anoAtual = new Date().getFullYear();
        const anoData = moment(data).year();
        const mesSolicitacao = new Date().getMonth() + 1;
      
        if (quantosAnos === 1) {
          if(anoAberturaEmpresa === anoData){
            return true;
          }
          // Regra para Balanço 01
          if (mesSolicitacao <= 6) {           
            // Primeiro semestre: ano pode ser do ano anterior ou dois anos antes
            return anoData === anoAtual - 1 || anoData === anoAtual - 2;
          } else {
            // Segundo semestre: ano pode ser apenas do ano anterior
            return anoData === anoAtual - 1;
          }
        } else if (quantosAnos === 2) {
          // Regra para Balanço 02
          if (mesSolicitacao <= 6) {
            // Primeiro semestre: ano pode ser dois ou três anos antes
            return anoData === anoAtual - 2 || anoData === anoAtual - 3;
          } else {
            // Segundo semestre: ano pode ser apenas dois anos antes
            return anoData === anoAtual - 2;
          }
        }
      }
    },
  

    obrigarBalanco2() {
      let regularidadeFiscTrabAberturaEmp = this.model.regularidadeFiscTrab.find(
          x => x.tipDocumento === 1
      );


      if (!regularidadeFiscTrabAberturaEmp || !regularidadeFiscTrabAberturaEmp.dtAberturaEmpresa) {
          return 'semBalanco2'; // Se não houver data de abertura, não obriga
      }

      // Ajustando a data de abertura se estiver entre 15/12 e 31/12
      let dataAbertura = moment(regularidadeFiscTrabAberturaEmp.dtAberturaEmpresa);
      if (dataAbertura.isBetween(`${dataAbertura.year()}-12-15`, `${dataAbertura.year()}-12-31`, null, '[]')) {
          dataAbertura.add(1, 'year').startOf('year');
      }

      let dataDoisAnos = dataAbertura.clone().add(2, 'years');
      let dataAtual = moment(); // Data do dia atual

      // Caso a empresa tenha menos de 2 anos, nunca obriga
      if (dataAtual.isBefore(dataDoisAnos)) {
          return 'Nobrigabalanco2';
      }

      // Calcula o último dia útil de junho do ano atual
      let ultimoDiaUtilJunho = moment(`${dataAtual.year()}-06-30`);
      if (ultimoDiaUtilJunho.day() === 6) {
          ultimoDiaUtilJunho.subtract(1, 'days'); // Se for sábado, volta para sexta
      } else if (ultimoDiaUtilJunho.day() === 0) {
          ultimoDiaUtilJunho.subtract(2, 'days'); // Se for domingo, volta para sexta
      }

      // Se completou 2 anos no primeiro semestre e ainda não passou do último dia útil de junho
      if (dataDoisAnos.year() === dataAtual.year() &&
          dataDoisAnos.month() < 6 &&
          dataAtual.isBefore(ultimoDiaUtilJunho)
      ) {
          return 'Nobrigabalanco2';
      }

        return 'obrigabalanco2'; // Se já passou do prazo, exige normalmente
    },

 
    getListaDocsQualificacaoTecnica() {
      //Pegar os possiveis documentos de qualificacao tecnica de acordo com a familia
      dominioService
        .getListaDocsQualificacaoTecnica(this.model.familiaSolicitacao)
        .then(response => { /*resposta do servico*/
          this.listaDocsQualificacaoTecnica.lista = response.data; /*dados de retorno*/

        });
    },

    validRegularidadeFiscal() {
      //Validar a regularidade fiscal

    
      if (this.$refs.regularidadeFiscal.validate()) {
        this.listaRegularidadeFiscTrab = [];
        Object.keys(this.tipoDocumento).forEach(chave => {
          delete this.tipoDocumento[chave].$id;
          const obj = {
            regularidadeFiscTrab: this.tipoDocumento[chave],
            file: this.tipoDocumento[chave].file
          };
          this.listaRegularidadeFiscTrab.push(obj);
        });
        this.hasErrorRegularidadeFiscal = false;
        return true;
      } else {
        this.hasErrorRegularidadeFiscal = true;
        return false;
      }
    },  

    validRegularidadeFiscalDatas() {
      //Validar a regularidade fiscal por datas

     let temErro = false;

      Object.values(this.model.regularidadeFiscTrab).forEach(item => {
       
        if (item.arquivoUpload && (!item.dtVencimento || !item.dtEmissao) && item.tipDocumento != 1 
        && item.tipDocumento != 2
        && item.tipDocumento != 3){
          temErro = true;
        
        }
      });
      
     if(temErro){
      this.setErro(
        "Verique as datas dos documentos",
        "tab-regularidadeFiscal"
      );  
      return false;
    }
    return true;
    },  

    isValidField(field) {
      return field !== '' && field !== null && field !== 0;
    },


    ValidaAnexoBalanco2() {
      if (
        this.model.tipoCertificado === 1 &&
        this.obrigarBalanco2() === 'obrigabalanco2' &&
        (!this.model.balancoFinanceiro.arquivoUpload02 || this.model.balancoFinanceiro.arquivoUpload02 === '')
      ) {
        this.setErro(
          "O anexo do balanço 2 é obrigatório", 
          "tab-qualificacao"
        );
        return false;
      }
    
      return true;
    },
    VerificaBalanco(){
      const dataValB1 = this.model.balancoFinanceiro.dtValidadeBalanco; // data no formato "2025-06-30T03:00:00"
      const hoje = new Date(); // Data atual
      const dataValidade = new Date(dataValB1);
      
      // Zera as horas de hoje e de dataValidade para comparação correta
      hoje.setHours(0, 0, 0, 0);
      dataValidade.setHours(0, 0, 0, 0);
      
      const anoAtual = hoje.getFullYear();
      const dataInicioPrimeiroSemestre = new Date(anoAtual, 0, 1); // 01/01 do ano atual
      const dataFimPrimeiroSemestre = new Date(anoAtual, 5, 30); // 30/06 do ano atual
      const dataJunhoAnoSeguinte = new Date(anoAtual + 1, 5, 30); // 30/06 do ano seguinte
      
      // Zera as horas das datas comparativas também
      dataInicioPrimeiroSemestre.setHours(0, 0, 0, 0);
      dataFimPrimeiroSemestre.setHours(0, 0, 0, 0);
      dataJunhoAnoSeguinte.setHours(0, 0, 0, 0);
      if (((
            (hoje >= dataInicioPrimeiroSemestre && hoje <= dataFimPrimeiroSemestre && dataValidade < hoje 
              && dataValidade.getFullYear() === hoje.getFullYear() - 1) ||
            (hoje > dataFimPrimeiroSemestre && dataValidade < hoje && dataValidade.getFullYear() === hoje.getFullYear())
          ) &&
          (
            !this.$verificaPerfilHabilitador() ||
            (this.$verificaPerfilHabilitador() && this.model.balancoFinanceiro.arquivoUploadSituacao === 2)
          ))){
       
        if (this.model.balancoFinanceiro.arquivoUpload && this.model.balancoFinanceiro.arquivoUpload.includes("https"))
        {
          return true;
        }
      
      }
      return false;
    },

    validQualificacao() {
      
      // ✅ 1) Se NÃO estiver em abas relacionadas à qualificação, não valida balanço
      if (this.activeTab !== "tab-formulariosDeclaracoes" &&
        this.activeTab !== "tab-qualificacao") {
      return true;
      }

      // ✅ 2) Se ainda não existe estrutura de balanço (nova solicitação), evita acessar null
      if (!this.model ||
          !this.model.balancoFinanceiro ||
          !this.modelQualificacao ||
          !this.modelQualificacao.balancoFinanceiro) {
        return true;
      }
      
      // 🔧 SINCRONIZAÇÃO BIDIRECIONAL: model → modelQualificacao (POST-backend)
      if (this.model.balancoFinanceiro) {
        this.modelQualificacao.balancoFinanceiro.file = this.model.balancoFinanceiro.file || this.modelQualificacao.balancoFinanceiro.file;
        this.modelQualificacao.balancoFinanceiro.arquivoUpload = this.model.balancoFinanceiro.arquivoUpload || this.modelQualificacao.balancoFinanceiro.arquivoUpload;
        console.log('DEBUG validQualificacao: SINCRONIZOU model → modelQualificacao.balancoFinanceiro.file');
      }

      if(this.model.tipoCertificado == 1){

        var livro = this.model.balancoFinanceiro.numLivroDiario;
        if (this.model.balancoFinanceiro.numLivroDiario == null || this.model.balancoFinanceiro.numLivroDiario == '') {
          livro= this.modelQualificacao.balancoFinanceiro.numLivroDiario;
        }
    
        var dtBalanco = this.model.balancoFinanceiro.dtBalanco;
        if (this.model.balancoFinanceiro.dtBalanco == null || this.model.balancoFinanceiro.dtBalanco == '') {
          dtBalanco = this.modelQualificacao.balancoFinanceiro.dtBalanco;
        }
        else{
          const dtBalancoValido = this.validaAnoAnterior(
           this.model.balancoFinanceiro.dtBalanco,
            1
          );
         
          if (!dtBalancoValido && this.abaAtiva == "tab-formulariosDeclaracoes" &&
           (!this.$verificaPerfilHabilitador() || (this.$verificaPerfilHabilitador() 
           && this.model.balancoFinanceiro.arquivoUploadSituacao === 2))) {
            this.setErro("A data do balanço 1 deve ser do ano anterior ao vigente.", 'tab-qualificacao');
            return false;
          }
        }
    
        if (
          this.model.tipoCertificado === 1 &&
          (this.abaAtiva === "tab-formulariosDeclaracoes" ) &&
          this.model.balancoFinanceiro
        ) {
          const hoje = new Date();
          hoje.setHours(0, 0, 0, 0); // zera hora atual
          
          const validadeBalanco = new Date(this.model.balancoFinanceiro.dtValidadeBalanco);
          validadeBalanco.setHours(0, 0, 0, 0); // zera hora do vencimento
          
          const balanco1Vencido =
           validadeBalanco < hoje &&
           this.model.balancoFinanceiro.arquivoUpload &&
           this.model.balancoFinanceiro.arquivoUpload.includes("https");
           
          if ((balanco1Vencido && !this.$verificaPerfilHabilitador()) || (balanco1Vencido  && this.$verificaPerfilHabilitador() && this.model.balancoFinanceiro.arquivoUploadSituacao === 2 )) {
            this.setErro(
              "Seu balanço 1 está vencido. Atualize-o",
              "tab-qualificacao"
            );
            return false;
          }
        }
    
        if(this.model.tipoCertificado === 1 && this.VerificaBalanco() && this.abaAtiva == "tab-formulariosDeclaracoes" )
        {
          this.setErro(
          "Campos do Balanço 1 estão vazios, verifique.", 
          "tab-qualificacao"
          );
        }
    
        if (this.model.balancoFinanceiro.dtBalanco02) {
          const dtBalancoValido2 = this.validaAnoAnterior(
           this.model.balancoFinanceiro.dtBalanco02,
            2
          );
    
          if (!dtBalancoValido2 && this.abaAtiva == "tab-formulariosDeclaracoes" &&
           (!this.$verificaPerfilHabilitador() || (this.$verificaPerfilHabilitador() 
           && this.model.balancoFinanceiro.arquivoUploadSituacao02 === 2))) {
            this.setErro("A data do balanço 2 deve ser do ano anterior ao vigente.", 'tab-qualificacao');
            return false;
          }
        }
    
        console.log('Valores:', ativoCirculante, passivoCirculante);
    
        var arquivoUpload = this.model.balancoFinanceiro.arquivoUpload;
        if (this.model.balancoFinanceiro.arquivoUpload == null || this.model.balancoFinanceiro.arquivoUpload == '') {
          arquivoUpload = this.modelQualificacao.balancoFinanceiro.file;
        }
        var ativoCirculante = this.model.balancoFinanceiro.ativoCirculante;
        if (this.model.balancoFinanceiro.ativoCirculante == null || this.model.balancoFinanceiro.ativoCirculante == '') {
          ativoCirculante = Number(this.modelQualificacao.balancoFinanceiro.ativoCirculante);
        }
        var passivoCirculante = this.model.balancoFinanceiro.passivoCirculante;
        if (this.model.balancoFinanceiro.passivoCirculante == null || this.model.balancoFinanceiro.passivoCirculante == '') {
          passivoCirculante = Number(this.modelQualificacao.balancoFinanceiro.passivoCirculante);
        }
        var dtValidadeBalanco = this.model.balancoFinanceiro.dtValidadeBalanco;
        if (this.model.balancoFinanceiro.dtValidadeBalanco == null || this.model.balancoFinanceiro.dtValidadeBalanco == '') {
          dtValidadeBalanco = this.modelQualificacao.balancoFinanceiro.dtValidadeBalanco;
        }
    
        if(this.obrigarBalanco2() == 'obrigabalanco2'){
    
            var arquivoUpload2 = this.model.balancoFinanceiro.arquivoUpload02;
                if (this.model.balancoFinanceiro.arquivoUpload02 == null || this.model.balancoFinanceiro.arquivoUpload02 == '') {
                  arquivoUpload2 = this.modelQualificacao.balancoFinanceiro.file02;
                }
            var livro2 = this.model.balancoFinanceiro.numLivroDiario02;
            if (this.model.balancoFinanceiro.numLivroDiario02 == null || this.model.balancoFinanceiro.numLivroDiario02 == '') {
             
              livro2= this.modelQualificacao.balancoFinanceiro.numLivroDiario02;
            }
    
            var dtBalanco2 = this.model.balancoFinanceiro.dtBalanco02;
            if (this.model.balancoFinanceiro.dtBalanco02 == null || this.model.balancoFinanceiro.dtBalanco02 == '') {
              dtBalanco2 = this.modelQualificacao.balancoFinanceiro.dtBalanco02;
            }
    
            var dtValidadeBalanco02 = this.model.balancoFinanceiro.dtValidadeBalanco02;
            if (this.model.balancoFinanceiro.dtValidadeBalanco02 == null || this.model.balancoFinanceiro.dtValidadeBalanco02 == '') {
              dtValidadeBalanco02 = this.modelQualificacao.balancoFinanceiro.dtValidadeBalanco02;
            }
    
            const fields2 = [
              { name: 'numLivroDiario02', value: livro2},
              { name: 'dtBalanco02', value: dtBalanco2 },
              { name: 'file', value: arquivoUpload2 }
            ];
            if (this.$verificaPerfilHabilitador()) {
              fields2.push({ name: 'dtValidadeBalanco', value: dtValidadeBalanco02 });
            }
    
            for (const field of fields2) {          
              if (!this.isValidField(field.value)) {
                if(this.abaAtiva == "tab-qualificacao"){
                this.$refs.qualificacaoEconomica.validate();
                }
                console.log(field);
                this.setErro("Há campos de preenchimento obrigatório no Balanço 02 sem preenchimento, gentileza verificar!", 'tab-qualificacao');
                return false;
              }
            }
        }
    
            const fields = [
              { name: 'numLivroDiario', value: livro},
              { name: 'dtBalanco', value: dtBalanco },
              { name: 'file', value: arquivoUpload }
            ];
    
             
            // Verifique se a regra é atendida antes de adicionar dtValidadeBalanco
            if (this.$verificaPerfilHabilitador()) {
              fields.push({ name: 'dtValidadeBalanco', value: dtValidadeBalanco });
            }
    
            for (const field of fields) {         
              if (!this.isValidField(field.value)) {
                if(this.abaAtiva == "tab-qualificacao"){
                this.$refs.qualificacaoEconomica.validate();
                }
                
                this.setErro("Há campos de preenchimento obrigatório no Balanço 01 sem preenchimento, gentileza verificar!", 'tab-qualificacao');
                return false;
              }
            }
    
        // 🔧 === VALIDAÇÃO SIMPLIFICADA DE ANO/DATA (SUBSTITUI TODO O BLOCO COMPLEXO) ===
        console.log('DEBUG validQualificacao - Sincronização:', {
          anoBalanco1_qualificacao: this.modelQualificacao.balancoFinanceiro.anoBalanco,
          dtBalanco1_qualificacao: this.modelQualificacao.balancoFinanceiro.dtBalanco,
          anoBalanco2_qualificacao: this.modelQualificacao.balancoFinanceiro.anoBalanco2,
          dtBalanco2_qualificacao: this.modelQualificacao.balancoFinanceiro.dtBalanco02
        });
    
        // Balanço 1
        if (this.modelQualificacao.balancoFinanceiro.anoBalanco) {
          const dataBalanco1 = new Date(this.modelQualificacao.balancoFinanceiro.dtBalanco);
          if (!isNaN(dataBalanco1.getTime()) && 
              this.modelQualificacao.balancoFinanceiro.anoBalanco != dataBalanco1.getFullYear()) {
            this.setErro("O ano do balanço deve ser igual ao ano da data do balanço", 'tab-qualificacao');
            return false;
          }
        }
    
        // Balanço 2
        if (this.modelQualificacao.balancoFinanceiro.anoBalanco2) {
          const dataBalanco2 = new Date(this.modelQualificacao.balancoFinanceiro.dtBalanco02);
          if (!isNaN(dataBalanco2.getTime()) && 
              this.modelQualificacao.balancoFinanceiro.anoBalanco2 != dataBalanco2.getFullYear()) {
            this.setErro("O ano do balanço 2 deve ser igual ao ano da data do balanço 2", 'tab-qualificacao');
            return false;
          }
        }
        // 🔧 === FIM DA VALIDAÇÃO SIMPLIFICADA ===
    
            const documentoCNPJ = this.model.regularidadeFiscTrab.find(doc => doc.tipDocumento === 1);
    
            if (documentoCNPJ && documentoCNPJ.dtAberturaEmpresa == null) {
              this.setErro("O Campo Data de Abertura da Empresa do Documento CNPJ é Obrigatório", 'tab-regularidadeFiscal');
              return false;
            }
              if(this.activeTab ==  "tab-qualificacao"){
                this.model.balancoFinanceiro = this.modelQualificacao.balancoFinanceiro;
                this.model.concordataFalencia = this.modelQualificacao.concordataFalencia;
              }
    
              if(this.model.balancoFinanceiro.arquivoUploadSituacao == 2 ){ 
                if (this.model.balancoFinanceiro.dtValidadeBalanco == null && this.$verificaPerfilHabilitador()) {
                  
                  this.setErro("A data de vencimento do Balanço 1 é obrigatório.", 'tab-qualificacao');
                  return false;
                }
                if(this.model.balancoFinanceiro.anoBalanco == null && this.$verificaPerfilHabilitador()){
                    
                  this.setErro(
                  "O campo ano do balanço é obrigatório",
                  "tab-qualificacao"
                );
                return false;
            }
            }      
              
            if(this.model.balancoFinanceiro != null){
              if(this.model.balancoFinanceiro.arquivoUploadSituacao02 == 2 ){      
                  if(this.model.balancoFinanceiro.dtValidadeBalanco02 == null && this.$verificaPerfilHabilitador()){
                
                      this.setErro(
                      "O campo data de vencimento do balanço 2 é obrigatório",
                      "tab-qualificacao"
                    );
                    return false;
                  }
                  if(this.model.balancoFinanceiro.anoBalanco2 == null && this.$verificaPerfilHabilitador()){
                    
                      this.setErro(
                      "O campo ano do balanço 2 é obrigatório",
                      "tab-qualificacao"
                    );
                    return false;
                  }
                }
              }
    
            if (this.model.tipFornecedor === 'J' && this.modelQualificacao.balancoFinanceiro.numLivroDiario)
            {
              if (this.totaisContas.ativoTotal !== this.totaisContas.passivoTotal) {
                this.setErro("O Ativo Total não pode ser diferente do Passivo Total.", 'tab-qualificacao');
                return false;
              } 
    
              if (this.totaisContas.ativoTotal <= 0.00 || this.totaisContas.ativoTotal == null){
                this.setErro("O Ativo Total não pode ser igual a zero.", 'tab-qualificacao');
                return false;
              }
    
              if (this.totaisContas.passivoTotal <= 0.00 || this.totaisContas.passivoTotal == null){
                this.setErro("O Passivo Total não pode ser igual a zero.", 'tab-qualificacao');
                return false;
              }
            }
    
            if (this.model.tipFornecedor === 'J' && this.modelQualificacao.balancoFinanceiro.numLivroDiario02 && (this.modelQualificacao.balancoFinanceiro.arquivoUpload02|| this.modelQualificacao.balancoFinanceiro.novoUpload02))
            {
              
                if ((this.totaisContas.ativoTotal02 !== this.totaisContas.passivoTotal02)  && (this.modelQualificacao.balancoFinanceiro.arquivoUpload02 || this.modelQualificacao.balancoFinanceiro.novoUpload02)) {
                  this.setErro("O Ativo Total do Balanço 2 não pode ser diferente do Passivo Total.", 'tab-qualificacao');
                  return false;
                }
    
                if ((this.totaisContas.ativoTotal02 <= 0.00 || this.totaisContas.ativoTotal02 == null) && (this.modelQualificacao.balancoFinanceiro.arquivoUpload02 || this.modelQualificacao.balancoFinanceiro.novoUpload02)){
                  this.setErro("O Ativo Total do Balanço 2 não pode ser igual a zero.", 'tab-qualificacao');
                  return false;
                }
    
                if ((this.totaisContas.passivoTotal02 <= 0.00 || this.totaisContas.passivoTotal02 == null)  && (this.modelQualificacao.balancoFinanceiro.arquivoUpload02|| this.modelQualificacao.balancoFinanceiro.novoUpload02)){
                  this.setErro("O Passivo Total do Balanço 2 não pode ser igual a zero.", 'tab-qualificacao');
                  return false;
                }
            }
    
            switch (this.activeTab) {        
              case "tab-qualificacao":
               
                return this.$refs.qualificacaoEconomica.validate();
              default:
                  return true;
            }
          }
          else
          {
            return true;
          }
    },

  

    validFormulariosDeclaracoes() {
      //Validar formularios e declaracoes
      
      return this.$refs.formulariosDeclaracoes.validate();
    },
    
    validForm() {
      console.log(this.activeTab);
      //validar todo o form de acordo com a aba
      switch (this.activeTab) {
        case "tab-dados":
          return this.validDadosBasicos();
        case "tab-hab-juridica":
          return this.validHabJuridica();
        case "tab-familia":
          return this.validFamilia();
        case "tab-qualificacaoTecnica":
          return this.validQualificacaoTecnica();
        case "tab-regularidadeFiscal":
          return this.validRegularidadeFiscal();
        case "tab-qualificacao":
          return this.validQualificacao();
        case "tab-formulariosDeclaracoes":
          var ret = this.revalidaHabilitacaoJuridica() && this.validFormulariosDeclaracoes() && this.ValidaAnexoBalanco2() && this.validQualificacao() && this.validRegularidadeFiscalDatas();
       
          return ret;
        default:
          return this.validDadosBasicos();
      }
    },

    voltar() {
      //voltar para a Aba anterior, não tem persistencia no banco
      this.$store.commit("setCalcLimpa", {
        setCalcLimpa: 2
        });
      switch (this.activeTab) {
        case "tab-dados":
          if (this.$verificaPerfilHabilitador()) {
            this.$router.push("/arearestrita/habilitador/solicitacao");
          } else {
            this.$router.push("/arearestrita/cadastrador/solicitacao");

          }
          break;
        case "tab-regularidadeFiscal":
          this.listaExigidos();
          if(this.listaDocsExigidos.length > 0 || this.listaDocsElegiveis.length >0){
            this.abaAtiva = "tab-qualificacaoTecnica";
            this.activeTab = this.abaAtiva;            
          }
          else{
            this.abaAtiva = "tab-familia";
            this.activeTab = this.abaAtiva;
          }
          break;
        case "tab-familia":
          if (this.model.tipFornecedor !== "F") {
            this.abaAtiva = "tab-hab-juridica";
            this.activeTab = this.abaAtiva;           
          } else {
            this.abaAtiva = "tab-dados";
            this.activeTab = this.abaAtiva;
          }
          break;
        case "tab-hab-juridica":
          this.setAbaDadosBasicos();
          break;
        case "tab-qualificacaoTecnica":
          this.abaAtiva = "tab-familia";          
          this.activeTab = this.abaAtiva;         
          break;
        case "tab-qualificacao":
          this.abaAtiva = "tab-regularidadeFiscal";
          this.activeTab = this.abaAtiva;          
          break;
        case "tab-formulariosDeclaracoes":
          this.abaAtiva = this.model.tipoCertificado !== 1 ? "tab-regularidadeFiscal" : "tab-qualificacao";
          this.activeTab = this.abaAtiva;         
          break;
        default:
          this.setAbaDadosBasicos();
      }
      this.setAbaVoltar(this.activeTab);
    },

    setAbaVoltar(abaNova){
      this.$store.commit("setAba", {
        abaAtiva: abaNova
      });
    },
    setAbaDadosBasicos(){
      this.abaAtiva = "tab-dados";
      this.activeTab = this.abaAtiva;
      this.setAbaVoltar(this.activeTab);

      window.location.reload();
    },

    enviar() {

      //método para enviar a solicitacao para o habilitador
      if (this.validForm() && this.validModelFormulariosDeclaracoes()) {
      this.verificaAtualizacaoCartaoCNPJ();
      this.model.unidadeSolicitante = this.model.unidadeSolicitante || "";
      const validacaoContratoSocial = this.validaContratoSocialCartaoCNPJ();
        
        // ───────────────────────────────────────────────────────────────
        // REGRA 1: BLOQUEAR APENAS SE ESTIVER NA ABA DE REGULARIDADE FISCAL
        // ───────────────────────────────────────────────────────────────
        
        if (this.activeTab === 'tab-formulariosDeclaracoes') {
            // ✅ Está na aba de Regularidade Fiscal → BLOQUEAR se inválido
            
            if (!validacaoContratoSocial.valido) {
                // ❌ BLOQUEIA NAVEGAÇÃO nesta aba
                this.erros = {
                    erro: true,
                    msg: validacaoContratoSocial.mensagem,
                    obj: ['contratoSocial', 'cartaoCNPJ'],
                    abaErro: 'tab-formulariosDeclaracoes'
                };
                
                this.$toast.error(validacaoContratoSocial.mensagem);
                
                return false; // ❌ BLOQUEIA - Não permite avançar
            }
        } else {
            // ───────────────────────────────────────────────────────────
            // REGRA 2: NAS OUTRAS ABAS - APENAS MARCAR FLAG (NÃO BLOQUEIA)
            // ───────────────────────────────────────────────────────────
            
            if (!validacaoContratoSocial.valido) {
                // ✅ NÃO está na aba de Regularidade Fiscal → APENAS ALERTAR
                
                // Marcar flag para exibir alerta visual quando chegar na aba
                this.contratoSocialAlterado = true;                               
                // ✅ NÃO retorna false - Permite prosseguir normalmente
            }
        }
      fornecedorService
      .enviarFornecedor({
      fornecedorSolicitacao: this.model,
      file: this.upload.file,
      listaRegularidadeFiscTrab: this.listaRegularidadeFiscTrab,
      listaDocumentosSolicitacao: this.montaListaDocumentosSolicitacao(),
      listaDeclaracao: this.fornecedorDeclaracaoVm.lista,
      modelQualificacao: this.modelQualificacao,
      listaAnexofamilia: this.listaAnexofamilia,
      aba: this.activeTab
      })
      .then(response => { /*resposta do servico*/
      this.model = response.data; /*dados de retorno*/
      if ( !this.$verificaPerfilCadastrador())
      {
      this.verificaNecessidadeImpressaoTermo();
      
      this.validaPopUpEnvioPrimeiraSolicitacao(this.model.numCgcFornecedor);
      
      }
      else
      {
      this.dialog = true;
      }
      
      
      });
      }
    },

    verificaNecessidadeImpressaoTermo()
    {
      let numCgcFornecedor =
        this.$route.params.id && this.$verificaPerfilHabilitador()
          ? this.$route.params.id
          : null;
      numCgcFornecedor = this.numCgcFornecedorProp ? this.numCgcFornecedorProp.texto : numCgcFornecedor

      

      fornecedorService.getFornecedorSIMPAS(numCgcFornecedor,"sim").then(response => { /*resposta do servico*/

        let upload = {
          termoConcordanciaVeracidadeSaeb: this.verificaDoc(this.model.uploadDeclaracao.find(
            x => x.tipDocumento === this.enums.tipoUploadDeclaracao.find(
              y => y.chave === 'TermoConcordanciaVeracidadeSaeb').valor)),
        };
       
        if(response.data != "")
        {         
         if ( upload.termoConcordanciaVeracidadeSaeb != null && upload.termoConcordanciaVeracidadeSaeb != "" && upload.termoConcordanciaVeracidadeSaeb != 'Não Encontrado')
          {
            this.dialogFormSim = true; // não imprime o termo, volta direto pra o painel
          }
          else
          {           
            this.dialogForm = true; // para imprimir o termo
          }
        }
        else{
          if ( upload.termoConcordanciaVeracidadeSaeb != null && upload.termoConcordanciaVeracidadeSaeb != "" && upload.termoConcordanciaVeracidadeSaeb != 'Não Encontrado')
          {      
           
            this.dialogFormSim = true; // não imprime o termo, volta direto pra o painel
          }else{
           
          this.dialogForm = true; // para imprimir o termo
          }
        }

      })
      .catch(() => {

        this.dialogForm = true; // para imprimir o termo
        });
    },

    verificaDoc(obj) {
      var retorno = ""
      if (obj != null) {
        retorno = obj.arquivoUpload
      }
      return retorno;
    },

    fecharDialogEnviar(modelLogin) {
      //fechar a caixa de dialogo e redirecionar para a home
      this.dialog = false;
      if (this.$verificaPerfilCadastrador())
        this.$router.push("/arearestrita/cadastrador/solicitacao");
      else {

        let param = {
          Num_cgc_fornecedor: modelLogin.numCgcFornecedor.replace(
            /[^A-Z0-9]/gi,
            ""
          ),
          Senha: modelLogin.senha
        }
        console.log("OIII");
        //Refazendo o login do usuário para atualizar menu de acesso.
        if (modelLogin.senha)
        {
          loginService
            .logar(param)
            .then(response => { /*resposta do servico*/
              this.$store.commit("setToken", response.data.token);
              this.$store.commit("setTokenRefresh", response.data.tokenRefresh);

              this.$router.push("fornecedor-painel");
            })
            .catch(() => {
              this.$removePreload(); /*Ocultar o PreLoad*/
            });
        }
        else{
          this.$router.push("/fornecedor-painel");
        }

      }
    },
    fecharDialogFormEnviar() {
      //fechar a caixa de dialogo e redirecionar para a home
      this.dialogForm = false; 
      this.$router.push("/termo-declaracao-concordancia/"+ this.model.idFornecSolicitacao +"/2");

    },

    abrirResumoHabilitador() {
      //abrir o resumo do habilitador quando for de mesmo perfil
      if (this.$verificaPerfilCadastrador())
        this.$router.push("/arearestrita/cadastrador/solicitacao");
      else {

        if (this.$verificaPerfilHabilitador()) {
          this.$router.push("/resumo-habilitador/" + this.model.idFornecSolicitacao);
        } else {
          this.$router.push("/extrato");
        }
      }
    },
    
    revalidaHabilitacaoJuridica(){
      if(this.model.tipFornecedor === 'J'){
        let isValid = this.validHabJuridica();
        if((!isValid && !this.erros.erro) || !this.validHabJuridicaDocSolic()){
          this.setErro("Todos campos obrigatórios devem ser preenchidos","tab-hab-juridica");
          return false;
        }
        return true;
      }
      return true;
    },

    /**
     * Verifica se o Cartão CNPJ foi atualizado
     */
    verificaAtualizacaoCartaoCNPJ: function() {
      if (!this.isAlteracao) return true; // Não é alteração, não precisa verificar
      
      // Procurar Cartão CNPJ na regularidade fiscal - SEM optional chaining
      var cartaoCNPJ = null;
      
      if (this.model && this.model.regularidadeFiscTrab && Array.isArray(this.model.regularidadeFiscTrab)) {
        cartaoCNPJ = this.model.regularidadeFiscTrab.find(function(doc) {
          return doc.tipDocumento === 1; // Código do Cartão CNPJ
        });
      }
      
      if (!cartaoCNPJ) return false;
      
      // NOVA LÓGICA: Verificar se CNPJ foi alterado APÓS o Contrato Social
      var temArquivo = cartaoCNPJ.arquivoUpload !== null && 
                       cartaoCNPJ.arquivoUpload !== undefined && 
                       cartaoCNPJ.arquivoUpload !== "" &&
                       cartaoCNPJ.arquivoUpload !== "Não Encontrado";
                       
      var temData = cartaoCNPJ.dtEmissao !== null && 
                    cartaoCNPJ.dtEmissao !== undefined &&
                    cartaoCNPJ.dtEmissao !== "";
      
      // Se não tem contrato social alterado, aceitar qualquer CNPJ válido
      if (!this.contratoSocialAlterado) {
        return temArquivo && temData;
      }
      
      return false;
    },

    /**
     * NOVO MÉTODO: Resetar aprovações das famílias quando Contrato Social alterado
     * ESPECÍFICO para perfis Validador/Validador Master
     */
    resetarAprovacoesFamilias: function() {
      // Verificar se usuário é Validador/Validador Master
      if (!this.$verificaPerfilHabilitador()) {
        return false; // Não executar para outros perfis
      }    
      // === VERIFICAÇÃO POR ID SOLICITAÇÃO (MAIS CONFIÁVEL) ===
      var chaveResetSolicitacao = 'familias_resetadas_' + this.model.idFornecSolicitacao;
      
      if (sessionStorage.getItem(chaveResetSolicitacao)) {
    
        return false; // NÃO resetar novamente
      }
      
      // === VERIFICAÇÃO ADICIONAL: SESSÃO ATUAL ===
      if (this.familiasJaResetadasParaReanalise) {
     
        return false; // NÃO resetar novamente
      }
   
      if (this.model && this.model.familiaSolicitacao && Array.isArray(this.model.familiaSolicitacao)) {
        var familiasAlteradas = false;
        var familiasResetadas = [];
        
        // this.model.familiaSolicitacao.forEach(function(familia) {
        //   // Se família estava aprovada (situação 2), resetar para reanálise
        //   if (familia.familiaFornecSituacao === 2) {
           
        //     // Salvar dados da família resetada
        //     familiasResetadas.push({
        //       codFamilia: familia.familiaAssociada.codFamilia,
        //       descFamilia: familia.familiaAssociada.descFamilia,
        //       situacaoAnterior: familia.familiaFornecSituacao
        //     });
            
        //     // Resetar status
        //     familia.familiaFornecSituacao = null;
        //     familia.dtRejeicao = null;
        //     familia.idMotivoIndeferimentoArquivo = null;
            
        //     familiasAlteradas = true;
        //   }
        // });
        // console.log("familiasAlteradas" );
        //  console.log(familiasAlteradas );
        if (true) {
        
          // === MARCAR COMO RESETADO PERMANENTEMENTE ===
          this.familiasJaResetadasParaReanalise = true;
          this.timestampResetFamilias = Date.now();
          
          // === PERSISTIR NO SESSION STORAGE (CHAVE POR SOLICITAÇÃO) ===
          sessionStorage.setItem(chaveResetSolicitacao, JSON.stringify({
            timestamp: this.timestampResetFamilias,
            totalResetadas: familiasResetadas.length,
            familiasAfetadas: familiasResetadas
          }));
          
          // Emitir evento para notificar componente família
          if (this.$root && this.$root.$emit) {
           
            this.$root.$emit('familiasResetadasParaReanalise', {
              resetadas: true,
              motivoReanalise: 'Atualização do CNPJ após alteração no Contrato Social',
              timestamp: this.timestampResetFamilias,
              familiasAfetadas: familiasResetadas,
              totalResetadas: familiasResetadas.length,
              solicitacaoId: this.model.idFornecSolicitacao
            });
          }
          
          return true;
        }
      }     
      return false;
    },

    /**
     * NOVO MÉTODO: Comunicação entre componentes via $root
     */
    notificarAlteracaoContratoSocial: function() {
      if (this.$root && this.$root.$emit) {
        this.$root.$emit('contratoSocialAlterado', {
          alterado: true,
          timestamp: Date.now()
        });
      }
    },

    /**
     * NOVO MÉTODO: Limpar flags de reset quando análise finalizada
     */
    limparFlagsResetFamilias: function() {
      if (this.$verificaPerfilHabilitador() && this.model && this.model.idFornecSolicitacao) {
        var chaveResetSolicitacao = 'familias_resetadas_' + this.model.idFornecSolicitacao;
        
        // Verificar se todas famílias foram reavaliadas
        var todasReavaliadas = true;
        if (this.model.familiaSolicitacao && Array.isArray(this.model.familiaSolicitacao)) {
          todasReavaliadas = this.model.familiaSolicitacao.every(function(familia) {
            return familia.familiaFornecSituacao !== null;
          });
        }
        
        if (todasReavaliadas) {
   
          // Limpar sessão
          this.familiasJaResetadasParaReanalise = false;
          this.timestampResetFamilias = null;
          
          // Limpar storage permanente
          sessionStorage.removeItem(chaveResetSolicitacao);
          
          return true;
        }
      }
      
      return false;
    },
  }
};
